import type {
  AppLayout,
  HiddenLayout,
  LayoutV2,
  SecondaryLayoutData,
} from "~/core";

export const isLayoutV2 = (value: AppLayout): value is LayoutV2 => {
  return value?.__typename === "layout_v2";
};

export const isHiddenLayout = (value: AppLayout): value is HiddenLayout => {
  return value?.__typename === "hidden_layout";
};

export const isSecondaryLayout = (
  value: AppLayout,
): value is SecondaryLayoutData => {
  return value?.__typename === "secondary_layout";
};
